<template>
  <section class="hero-section">
    <div class="hero-container">
      <div class="hero-content">
        <h1 class="hero-title">{{ translations[locale].title }}</h1>
        <p class="hero-subtitle">{{ translations[locale].subtitle }}</p>
        <div class="hero-buttons">
          <button class="btn-primary"><a href="https://www.komachain.org">{{ translations[locale].whitepaper
              }}</a></button>
          <button class="btn-outline"><a href="https://www.komascan.io">{{ translations[locale].join }}</a></button>
        </div>
        <div class="feature-cards">
          <div class="feature-card">
            <div class="feature-icon">
              <img src="@/assets/img/icon_q1.png" alt="performance" />
            </div>
            <h3>{{ translations[locale].features.performance.title }}</h3>
            <p>{{ translations[locale].features.performance.description }}</p>
          </div>
          <div class="feature-card">
            <div class="feature-icon">
              <img src="@/assets/img/icon_q2.png" alt="community" />
            </div>
            <h3>{{ translations[locale].features.community.title }}</h3>
            <p>{{ translations[locale].features.community.description }}</p>
          </div>
          <div class="feature-card">
            <div class="feature-icon">
              <img src="@/assets/img/icon_q3.png" alt="innovation" />
            </div>
            <h3>{{ translations[locale].features.innovation.title }}</h3>
            <p>{{ translations[locale].features.innovation.description }}</p>
          </div>
          <div class="feature-card">
            <div class="feature-icon">
              <img src="@/assets/img/icon_q4.png" alt="national" />
            </div>
            <h3>{{ translations[locale].features.national.title }}</h3>
            <p>{{ translations[locale].features.national.description }}</p>
          </div>
          <div class="feature-card">
            <div class="feature-icon">
              <img src="@/assets/img/icon_q5.png" alt="huge" />
            </div>
            <h3>{{ translations[locale].features.huge.title }}</h3>
            <p>{{ translations[locale].features.huge.description }}</p>
          </div>
          <div class="feature-card">
            <div class="feature-icon">
              <img src="@/assets/img/icon_q6.png" alt="dragon" />
            </div>
            <h3>{{ translations[locale].features.dragon.title }}</h3>
            <p>{{ translations[locale].features.dragon.description }}</p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { ref, computed } from 'vue'
import { useStore } from '@/stores/language'

const store = useStore()
const locale = computed(() => store.locale)

const translations = {
  zh: {
    title: '構建去中心化的未來',
    subtitle: 'KOMA致力於打造新一代區塊鏈基礎設施,為去中心化應用提供高性能、安全可靠的運行環境',
    whitepaper: '查看白皮書',
    join: '加入社區',
    features: {
      performance: {
        title: '高性能交易',
        description: '支持每秒數萬筆交易處理,滿足企業級應用需求'
      },
      community: {
        title: '社區驅動',
        description: '由全球社區共同參與治理,實現真正的去中心化'
      },
      innovation: {
        title: '創新技術',
        description: '採用最前沿的區塊鏈科技,打造安全可靠的基礎設施'
      },
      national: {
        title: '阿斯塔國際',
        description: '大業縱橫基金會國際法務部〖國際法務執行機構〗'
      },
      huge: {
        title: '大業縱橫',
        description: '大業縱橫基金會國際業務部〖國際業務執行機構〗'
      },
      dragon: {
        title: '龍鳳呈祥',
        description: '創新與傳統的完美融合,開創區塊鏈新紀元'
      }
    }
  },
  en: {
    title: 'Building a Decentralized Future',
    subtitle: 'KOMA is dedicated to building next-generation blockchain infrastructure, providing high-performance, secure and reliable operating environment for decentralized applications',
    whitepaper: 'View Whitepaper',
    join: 'Join Community',
    features: {
      performance: {
        title: 'High Performance',
        description: 'Supporting tens of thousands of transactions per second, meeting enterprise-level application requirements'
      },
      community: {
        title: 'Community Driven',
        description: 'Governed by the global community, achieving true decentralization'
      },
      innovation: {
        title: 'Innovative Technology',
        description: 'Using cutting-edge blockchain technology to build secure and reliable infrastructure'
      },
      national: {
        title: 'Asta International',
        description: 'International Legal Department of Daye Zongheng Foundation [International Legal Execution Agency]'
      },
      huge: {
        title: 'Daye Zongheng',
        description: 'International Business Department of Daye Zongheng Foundation [International Business Execution Agency]'
      },
      dragon: {
        title: 'Dragon & Phoenix',
        description: 'Perfect fusion of innovation and tradition, pioneering a new era of blockchain'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.hero-section {
  background: linear-gradient(0deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0) 100%),
    radial-gradient(25% 50% at 50% 50%, #D8D8D8 0, rgba(216, 216, 216, 0) 100%);
  padding: 80px 0;
  position: relative;
}

.hero-container {
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 24px;
}

.hero-content {
  max-width: 896px;
  margin: 0 auto;
  text-align: center;
}

.hero-title {
  font-size: clamp(2.5rem, 5vw, 3.75rem);
  font-weight: 700;
  line-height: 1.2;
  margin-bottom: 1.5rem;
  background: linear-gradient(135deg, #60A5FA 0%, #A78BFA 100%);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
  letter-spacing: 0.05em;
  position: relative;

  &::after {
    content: '';
    position: absolute;
    bottom: -5px;
    left: 50%;
    transform: translateX(-50%);
    width: 60%;
    height: 2px;
    background: linear-gradient(90deg, transparent, #60A5FA, #A78BFA, transparent);
  }
}

.hero-subtitle {
  font-size: clamp(1rem, 2vw, 1.25rem);
  color: #D1D5DB;
  line-height: 1.4;
  margin-bottom: 2rem;
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
}

.hero-buttons {
  display: flex;
  gap: 1rem;
  justify-content: center;
  margin-bottom: 4rem;

  a {
    color: #FFFFFF;
    text-decoration: none;
  }
}

.btn-primary {
  padding: 0.75rem 2rem;
  background: #4F46E5;
  color: #FFFFFF;
  border: none;
  border-radius: 9999px;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background: #4338CA;
    transform: translateY(-1px);
  }
}

.btn-outline {
  padding: 0.75rem 2rem;
  background: transparent;
  color: #FFFFFF;
  border: 1px solid #4F46E5;
  border-radius: 9999px;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background: rgba(79, 70, 229, 0.1);
    transform: translateY(-1px);
  }
}

.feature-cards {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1.5rem;
  margin-top: 2rem;
}

.feature-card {
  background: rgba(31, 41, 55, 0.5);
  border-radius: 1rem;
  padding: 2rem;
  text-align: center;
  transition: transform 0.3s ease;

  &:hover {
    transform: translateY(-5px);
  }
}

.feature-icon {
  width: 48px;
  height: 48px;
  background: rgba(79, 70, 229, 0.2);
  border-radius: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 1.5rem;

  img {
    width: 24px;
    height: 24px;
  }
}

.feature-card h3 {
  color: #F8FAFC;
  font-size: 1.25rem;
  font-weight: 600;
  margin-bottom: 1rem;
}

.feature-card p {
  color: #9CA3AF;
  font-size: 1rem;
  line-height: 1.5;
}

// 响应式设计
@media screen and (max-width: 1024px) {
  .hero-container {
    padding: 0 2rem;
  }

  .feature-cards {
    gap: 1rem;
  }
}

@media screen and (max-width: 768px) {
  .hero-section {
    padding: 60px 0;
  }

  .hero-buttons {
    flex-direction: column;
    align-items: center;
  }

  .btn-primary,
  .btn-outline {
    width: 100%;
    max-width: 300px;
  }

  .feature-cards {
    grid-template-columns: 1fr;
    max-width: 400px;
    margin-left: auto;
    margin-right: auto;
  }
}

@media screen and (max-width: 480px) {
  .hero-section {
    padding: 40px 0;
  }

  .hero-container {
    padding: 0 1rem;
  }

  .feature-card {
    padding: 1.5rem;
  }
}

// 深色模式支持
@media (prefers-color-scheme: dark) {
  .hero-title {
    color: #F8FAFC;
  }

  .hero-subtitle {
    color: #9CA3AF;
  }

  .feature-card {
    background: rgba(31, 41, 55, 0.8);
  }
}
</style>